import { useImageSize } from "../hooks";
import { twMerge } from "tailwind-merge";
import FullServiceLarge from "./FullServiceLarge";

interface ImageHoverProps {
  refImage?: any;
  rounded?: boolean;
  backgroundImage?: string;
  isFullService?: boolean;
  className?: string;
}

export const ImageHover = ({ refImage, rounded, backgroundImage, isFullService, className }: ImageHoverProps) => {
  const { imageSize } = useImageSize({ refImage, rounded });
  if (!imageSize) return null;

  const wrapperStyle = {
    width: imageSize?.width,
    height: imageSize?.height,
    backgroundImage: `url(${backgroundImage})`,
    boxShadow: "0px 0px 8px rgba(13, 13, 73, 0.15)",
    backgroundColor: "#f7f8fb",
  };

  return (
    <div
      className={twMerge(
        "bg-cover bg-center box-content border-[2px] border-white shadow relative ",
        rounded ? "rounded-full" : "rounded",
        className,
      )}
      style={wrapperStyle}
    >
      {isFullService && <FullServiceLarge></FullServiceLarge>}
    </div>
  );
};
